import { render, staticRenderFns } from "./order-center.vue?vue&type=template&id=6c2e3ae0&scoped=true"
import script from "./order-center.vue?vue&type=script&lang=js"
export * from "./order-center.vue?vue&type=script&lang=js"
import style0 from "./order-center.vue?vue&type=style&index=0&id=6c2e3ae0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2e3ae0",
  null
  
)

export default component.exports